import React from "react";

const ContainerLayout = ({ className = "", children }) => {
  return <div className={`container ${className}`}>{children}</div>;
};

export default ContainerLayout;
